import styled from 'styled-components';

export const ContactNumber = styled.div`
  width: 100%;
  text-align: center;
  font-weight: bold;
  margin-top: 0.75rem;
`;

export const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
